








































































































import Vue from 'vue';
import { IInvoicingPointsItem } from '@/common/interfaces/partners.interface';
import OldFormatHelper from '../../helpers/OldFormatHelper';

interface IItemsViewInvoicingPointsComponent {
  formatHelper: typeof OldFormatHelper;
}

export default Vue.extend({
  data(): IItemsViewInvoicingPointsComponent {
    return {
      formatHelper: OldFormatHelper,
    };
  },
  props: {
    currency: {
      default: null,
      type: String,
    },
    items: {
      default: () => [],
      type: Array as () => IInvoicingPointsItem[],
    },
  },
  methods: {
    getItemImage(item: IInvoicingPointsItem): string {
      return item.image || ``;
    },
    getItemTitle(item: IInvoicingPointsItem): string {
      return item.title || ``;
    },
  },
});
